import React, { useContext, useState } from "react";
import { Button, Checkbox, Flag, Popup } from "semantic-ui-react";
import { DEFAULT_LANGUAGE_CODE } from "../../../_constants/constants";

import "./LanguageSelector.css";
import CustomLangFlag from "../../common/customLangFlag/CustomLangFlag";
import { LanguageContext } from "../../../store/LanguageContext";

const LanguageSelector = ({
    activeLang,
    setActiveLang,
    defaultDisplayedLangs,
    allowAdditions = true,
    allowedLangs = [DEFAULT_LANGUAGE_CODE],
    onLangAdd,
    onLangDelete,
}) =>
{
    const [addedLangs, setAddedLangs] = useState(new Set());

    const languageCtx = useContext(LanguageContext);
    const { languages } = languageCtx;

    const addDisplayLng = (lng) => 
    {
        setAddedLangs((set) => new Set([...set, lng]));
        if (onLangAdd)
        {
            onLangAdd(lng);
        }
    };

    const removeDisplayLng = (lng) =>
    {
        if (activeLang === lng)
        {
            setActiveLang(DEFAULT_LANGUAGE_CODE);
        }
        setAddedLangs((set) =>
        {
            set.delete(lng);
            return new Set(set);
        });

        if (onLangDelete)
        {
            onLangDelete(lng);
        }
    };


    let displayed = allowAdditions ? Array.from(new Set([...defaultDisplayedLangs, ...addedLangs])) : defaultDisplayedLangs;
    return (
        <div className="previewLanguageGroup">
            <div className="previewLanguageContent">
                {displayed.map((l) => (
                    <Button
                        key={l}
                        content={l.toUpperCase()}
                        active={l === activeLang}
                        onClick={() => setActiveLang(l)}
                    />
                ))}
                <Popup basic
                    className="previewLangDropdownPopup"
                    trigger={<Button disabled={!allowAdditions} className="btnDropdownPopup" icon="angle down" />}
                    on="click"
                    hideOnScroll
                    position='top center'
                    offset={[54,0]}
                >
                    {Object.values(languages || {})
                        .filter((lang) => allowedLangs.includes(lang.value))
                        .map(({ title, value }) => (
                            <CheckboxGroup
                                key={value}
                                checked={displayed.includes(value)}
                                name={title}
                                onChange={(checked) => checked ? addDisplayLng(value) : removeDisplayLng(value)}
                                onClick={() => setActiveLang(value)}
                                active={value === activeLang}
                                disabled={value === DEFAULT_LANGUAGE_CODE}
                            />
                        ))}
                </Popup>
            </div>
        </div>
    );
};

const CheckboxGroup = ({
    checked,
    name,
    disabled = false,
    onChange = () => null,
    onClick,
    active,
}) => (
    <div className="previewLangItem">
        <Checkbox className="checkboxLang" checked={checked} disabled={disabled} onChange={(e, { checked }) => onChange(checked)}/>
        <div className="checkboxLangTitle" onClick={onClick}>
            {(active) && <strong> {name}</strong>}
            {(!active) && <span> {name}</span>}
        </div>
    </div>
);

export default LanguageSelector;
